import React from 'react'
import PropTypes from 'prop-types'
import './features20.css'

const Features20 = (props) => {
  return (
    <div className="features20-layout thq-section-padding">
      <div className="features20-max-width thq-section-max-width">
        <div className="features20-content">
          <div className="features20-section-title">
            <div className="features20-content-wrapper">
              <h2 className="features20-title thq-heading-2">
                {props.feature1Title ?? "AI entrepreneurship Make-A-Thon"}
              </h2>
              <p className="features20-description thq-body-large">
                {props.feature1Description ?? (
                  ""
                )}
              </p>
            </div>
          </div>
        </div>
        <div className="features20-image-container">
          <img
            alt={props.feature1ImageAlt}
            src={props.feature1ImageSrc}
            className="thq-img-ratio-16-9 features20-image"
          />
        </div>
      </div>
    </div>
  )
}

Features20.defaultProps = {
  feature1Description: undefined,
  feature1ImageAlt: 'Inclusive AI Innovation',
  feature1Title: undefined,
  feature1ImageSrc: 'https://production-new-commonwealth-files.s3.eu-west-2.amazonaws.com/s3fs-public/styles/banner/public/2024-08/dsc08805-2.jpg?VersionId=En.5izgzGgBSpoaZ7LFlPKPH7OxUbV5Y&itok=5tvF6ACU',
}

Features20.propTypes = {
  feature1Description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  feature1ImageAlt: PropTypes.string,
  feature1Title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  feature1ImageSrc: PropTypes.string,
}

export default Features20
